import { RestrictedScope } from 'mormaii-web-presentation/restricted'
import type { ViewFactory } from 'wdc-cube-solid'

import { registerViews as registerCollaboratorsViews } from './collaborators'
import { registerViews as registerCompaniesViews } from './companies'
import { registerViews as registerCompanyUsersViews } from './company-users'
import { registerViews as registerDashboardViews } from './dashboard'
import { registerViews as registerIcpViews } from './icp'
import { registerViews as registerMonitoringViews } from './monitoring'
import { registerViews as registerMyDataViews } from './my-data'
import { registerViews as registerSleepReportViews } from './sleep-report'
import { registerViews as registerUserBaseViews } from './user-base'
import { RestrictedView } from './v-restricted'

/** A casca e tudo o que mora dentro dela. */
export function registerViews(rv: typeof ViewFactory.register) {
    rv(RestrictedScope, RestrictedView)

    registerDashboardViews(rv)
    registerCollaboratorsViews(rv)
    registerMonitoringViews(rv)
    registerCompaniesViews(rv)
    registerCompanyUsersViews(rv)
    registerMyDataViews(rv)
    registerUserBaseViews(rv)
    registerSleepReportViews(rv)
    registerIcpViews(rv)
}

export { RestrictedView }
